export function populateImage(item) {
  if (!item) {
    throw new Error('You must provide a valid item');
  }

  if (!item.coverImage) {
    throw new Error('You must provide a valid coverImage');
  }

  if (!item.coverImage.vertical) {
    throw new Error('You must provide a valid vertical coverImage');
  }

  return item.coverImage.vertical.path;
}
